/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import "./styles.css";

import { Pagination } from "swiper/modules";



const BrandSlider = () => {
  const brandLogos = [
    {
      heading: "Ferrari",
      img: "/assets/img/brandnew/ferari.png",
    },
    {
      heading: "Hyundai",
      img: "/assets/img/brandnew/hyundai.png",
    },
    {
      heading: "Mercedes Benz",
      img: "/assets/img/brandnew/mercerdies.png",
    },
    {
      heading: "Toyota",
      img: "/assets/img/brandnew/toyota.png",
    },
    {
      heading: "BMW",
      img: "/assets/img/brandnew/bmw.png",
    },
    {
      heading: "Nissan",
      img: "/assets/img/brandnew/nissan.png",
    },
    {
      heading: "Acura",
      img: "/assets/img/brandnew/acura.png",
    },
    {
      heading: "Audi",
      img: "/assets/img/brandnew/od.png",
    },
    {
      heading: "GMC",
      img: "/assets/img/brandnew/gmc.png",
    },
    {
      heading: "Honda",
      img: "/assets/img/brandnew/honda.png",
    },
  ];
  return (
    <>
      <div class="row mt-5 d-lg-block d-none">
        <div class="col-lg-6 mx-auto">
          <div class="site-heading text-center">
            <span class="site-title-tagline">
              <i class="flaticon-drive"></i> Popular Brands
            </span>
            <h2 class="site-title">
              Common Car <span>Makes</span>
            </h2>
            <div class="heading-divider"></div>
          </div>
        </div>
      </div>
      <div className="container mb-4 d-lg-block d-none">
        <Swiper
          slidesPerView={5}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="BrandSlider"
        >
          {brandLogos.map((logo) => (
            <SwiperSlide key={logo.id || logo.heading}>
              <a
                href={`/searchbrand?heading=${encodeURIComponent(logo.heading)}`}
                className="brand-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <h5>{logo.heading}</h5>
                <div className="ferrari-img">
                  <img
                    src={logo.img}
                    alt=""
                    data-animation="fadeInRight"
                    data-delay=".25s"
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default BrandSlider;
